import * as React from 'react';

interface Props {
  src: string,
  alt: string,
  className?: string
}

const LazyLoadImg = ({ src, alt, className }: Props): JSX.Element => (
  <img
    className={`lazyload ${className ?? ''}`}
    data-src={src}
    alt={alt}
  />
);

export default LazyLoadImg;
